<template>
  <div v-tooltip="{ content: text, placement: placement, classes: 'tight' }" class="vcv-help-tooltip">?</div>
</template>

<script>
export default {
  name: 'VcvHelpTooltip',

  props: {
    text: {
      type: String,
      default: ''
    },

    placement: {
      type: String,
      default: 'top-center'
    }
  }
};
</script>

<style lang="scss" scoped>
.vcv-help-tooltip {
  width: 20px;
  height: 20px;
  border-radius: 3px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background: $grey;
  color: $white;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s;

  &:hover {
    background: $blue-light-dark;
    transition: background 0.3s;
  }
}
</style>
